@if (!allSensitiveDataLoaded()) {
  <div
    class="fetch-all-content__sensitive-content"
    [class.error]="isSensitiveDataError()">
    <lucide-icon
      [name]="
        isSensitiveDataError() ? 'triangle-alert' : 'eye-off'
      "
      [size]="16" />
    @if (_permissionsService.hasOnlyViewerPermissions()) {
      <span>{{
        Label.get(
          'enterpriseAIThreads.fetchContentDescriptionViewer'
        )
      }}</span>
    } @else {
      <span>{{ description() }}</span>
      <app-button
        [isEnabled]="!isSensitiveDataLoading()"
        [buttonTextLabelPath]="
          isSensitiveDataError()
            ? 'enterpriseAIThreads.tryAgain'
            : 'enterpriseAIThreads.fetchContent'
        "
        [isUppercase]="false"
        (buttonClicked)="fetchContent($event)" />
    }
  </div>
}
